import { forEach as _forEach, indexOf as _indexOf, startsWith } from 'lodash';
import { UtilityService } from '../../core';
import { parsePhoneNumber } from 'libphonenumber-js';

const defaultRoles: any = ['appuser', 'anonymous'];
const ecapCorGuidGeneratorService = new UtilityService();
export class PlatformUserAccessManagementConfigModel<T> {
    TotalElements: number;
    TotalPages: number;
    Data: Array<T>;

    constructor() {
        this.TotalElements = 0;
        this.TotalPages = 0;
        this.Data = new Array<T>();
    }
}

export class UpdateUserCommand {
    ItemId?: string;
    DisplayName?: string;
    PhoneNumber?: string;
    Email: string;
    Active: boolean;
    Roles?: string[];
    UserId: string;
    TwoFactorEnabled: boolean;
    CountryCode?: string;
    Tags?: string[];
    Language: string;
    Salutation?: string;
    FirstName?: string;
    LastName?: string;
    PersonaEnabled?: boolean;
    Sex?: string;
    PersonInfo?: any;

    constructor(userInfo?, updatePersonInfoByDefaultInfo?) {
        userInfo = userInfo || {};
        this.FirstName = (userInfo && userInfo.FirstName) || '';
        this.LastName = (userInfo && userInfo.LastName) || '';
        this.DisplayName = (userInfo && userInfo.DisplayName) || this.FirstName + ' ' + this.LastName;
        this.Email = (userInfo && userInfo.Email) || '';
        this.Active = userInfo && userInfo.Active && true;
        this.Roles = userInfo && userInfo.Roles && this.getUpdatedUserRoles(userInfo.Roles);
        this.UserId = (userInfo && userInfo.UserId) || (userInfo && userInfo.ItemId);
        this.TwoFactorEnabled = this.getTwoFactorStatus(userInfo.TwoFactorEnabled);
        this.PhoneNumber = (userInfo && this.getValidPhoneNumber(userInfo.PhoneNumber)) || '';
        this.CountryCode =
            (userInfo && userInfo.CountryCode) || (this.PhoneNumber && this.getCountryCode(this.PhoneNumber)) || '';
        this.Tags = userInfo && userInfo.Tags;
        this.Language = (userInfo && userInfo.Language) || 'en-US';
        this.Salutation = (userInfo && userInfo.Salutation) || '';
        (this.PersonaEnabled = (userInfo && userInfo.PersonaEnabled) || false),
            (this.ItemId = (userInfo && userInfo.ItemId) || '');
        this.Sex = (userInfo && userInfo.Sex) || '';
        if (updatePersonInfoByDefaultInfo) {
            this.PersonInfo = userInfo && userInfo.PersonInfo;
        } else {
            this.PersonInfo = {
                FirstName: (userInfo && userInfo.FirstName) || '',
                LastName: (userInfo && userInfo.LastName) || '',
                DisplayName: (userInfo && userInfo.DisplayName) || this.FirstName + ' ' + this.LastName,
                Email: (userInfo && userInfo.Email) || '',
                Roles: this.Roles,
                PhoneNumber: this.PhoneNumber,
                Tags: userInfo ? userInfo.Tags : ['Person'],
                Salutation: this.Salutation
            };
        }
    }
    getValidPhoneNumber(phoneNumber: string) {
        if (!phoneNumber) return '';
        if (startsWith(phoneNumber, '+')) return phoneNumber;
        else {
            return '+' + phoneNumber;
        }
    }
    getUpdatedUserRoles(userRoles) {
        if (!userRoles) userRoles = [];
        _forEach(defaultRoles, role => {
            _indexOf(userRoles, role) > -1 ? null : userRoles.push(role);
        });
        return userRoles;
    }
    getCountryCode(phoneNumber) {
        let phoneNumberInfo = phoneNumber ? parsePhoneNumber(phoneNumber) : null;
        return phoneNumberInfo && phoneNumberInfo.country;
    }
    getTwoFactorStatus(twofactor) {
        if (twofactor == undefined || twofactor == null) return true;
        if (twofactor == false) return false;
        return true;
    }
}
export class CreateUserCommand {
    PersonaEnabled?: boolean;
    Password?: string;
    UserName?: string;
    Email: string;
    ItemId: string;
    DisplayName?: string;
    PhoneNumber?: string;
    ProfileImageUrl?: string;
    SignUp?: boolean;
    DefaultPassword?: string;
    RegisteredBy?: number;
    Roles: string[];
    CountryCode?: string;
    TwoFactorEnabled?: boolean;
    Tags?: string[];
    MailPurpose?: string;
    FirstName?: string;
    LastName?: string;
    Salutation?: string;
    Language?: string;
    HostDomain?: string;
    PersonInfo?: any;
    CopyEmailTo?: string[];
    AutoExpire?: boolean;
    ExpireOn?: Date;

    constructor(userInfo?, updatePersonInfoByDefaultInfo?) {
        userInfo = userInfo || {};
        this.FirstName = (userInfo && userInfo.FirstName) || '';
        this.LastName = (userInfo && userInfo.LastName) || '';
        this.DisplayName =
            (userInfo && userInfo.DisplayName) ||
            (this.FirstName || this.LastName ? this.FirstName + ' ' + this.LastName : '');
        this.Email = (userInfo && userInfo.Email) || '';
        this.Roles = userInfo && userInfo.Roles && this.getUpdatedUserRoles(userInfo.Roles);
        this.TwoFactorEnabled = this.getTwoFactorStatus(userInfo.TwoFactorEnabled); // (userInfo.TwoFactorEnabled == false || userInfo.TwoFactorEnabled == true) || true
        this.PhoneNumber = (userInfo && userInfo.PhoneNumber) || '';
        this.CountryCode =
            (userInfo && userInfo.CountryCode) || (this.PhoneNumber && this.getCountryCode(this.PhoneNumber)) || '';
        this.Tags = userInfo && userInfo.Tags;
        this.Language = (userInfo && userInfo.Language) || 'en-US';
        this.Salutation = (userInfo && userInfo.Salutation) || '';
        this.PersonaEnabled = (userInfo && userInfo.PersonaEnabled) || false;
        this.UserName = (userInfo && userInfo.UserName) || (userInfo && userInfo.Email);
        (this.ItemId = (userInfo && userInfo.ItemId) || ecapCorGuidGeneratorService.getNewGuid()),
            (this.Password = (userInfo && userInfo.Password) || '');
        this.MailPurpose = (userInfo && userInfo.MailPurpose) || '';
        this.AutoExpire = userInfo && userInfo.AutoExpire;
        this.CopyEmailTo = (userInfo && userInfo.CopyEmailTo) || [];
        this.DefaultPassword = (userInfo && userInfo.DefaultPassword) || '';
        this.HostDomain = (userInfo && userInfo.HostDomain) || '';
        this.RegisteredBy = (userInfo && userInfo.RegisteredBy) || 1;
        this.SignUp = userInfo && userInfo.SignUp;
        if (updatePersonInfoByDefaultInfo) {
            this.PersonInfo = userInfo && userInfo.PersonInfo;
        } else {
            this.PersonInfo = {
                FirstName: (userInfo && userInfo.FirstName) || '',
                LastName: (userInfo && userInfo.LastName) || '',
                DisplayName: (userInfo && userInfo.DisplayName) || this.FirstName + ' ' + this.LastName,
                Email: (userInfo && userInfo.Email) || '',
                Roles: this.Roles,
                PhoneNumber: this.PhoneNumber,
                Tags: userInfo ? userInfo.Tags : ['Person'],
                Salutation: this.Salutation
            };
        }
    }

    getUpdatedUserRoles(userRoles) {
        if (!userRoles) userRoles = [];
        _forEach(defaultRoles, role => {
            _indexOf(userRoles, role) > -1 ? null : userRoles.push(role);
        });
        return userRoles;
    }

    getCountryCode(phoneNumber) {
        let phoneNumberInfo = phoneNumber ? parsePhoneNumber(phoneNumber) : null;
        return phoneNumberInfo && phoneNumberInfo.country;
    }
    getTwoFactorStatus(twofactor) {
        if (twofactor == undefined || twofactor == null) return true;
        if (twofactor == false) return false;
        return true;
    }
}

export class CountryCode {
    countryCode = [];
    constructor() {
        this.countryCode = [
            'ax',
            'af',
            'al',
            'dz',
            'as',
            'ad',
            'ao',
            'ai',
            'aq',
            'ag',
            'ar',
            'am',
            'aw',
            'au',
            'at',
            'az',
            'bs',
            'bh',
            'bd',
            'bb',
            'by',
            'be',
            'bz',
            'bj',
            'bm',
            'bt',
            'bo',
            'ba',
            'bw',
            'bv',
            'br',
            'io',
            'bn',
            'bg',
            'bf',
            'bi',
            'bq',
            'kh',
            'cm',
            'ca',
            'cv',
            'ky',
            'cf',
            'td',
            'cl',
            'cn',
            'cx',
            'cc',
            'co',
            'km',
            'cd',
            'cg',
            'ck',
            'cr',
            'ci',
            'hr',
            'cu',
            'cw',
            'cy',
            'cz',
            'dk',
            'dj',
            'dm',
            'do',
            'ec',
            'eg',
            'sv',
            'gq',
            'er',
            'ee',
            'et',
            'fk',
            'fo',
            'fj',
            'fi',
            'fr',
            'gf',
            'pf',
            'tf',
            'ga',
            'gm',
            'ge',
            'de',
            'gh',
            'gi',
            'gr',
            'gl',
            'gd',
            'gp',
            'gu',
            'gt',
            'gg',
            'gn',
            'gw',
            'gy',
            'ht',
            'hm',
            'hn',
            'hk',
            'hu',
            'is',
            'in',
            'id',
            'ir',
            'iq',
            'ie',
            'im',
            'il',
            'it',
            'jm',
            'jp',
            'je',
            'jo',
            'kz',
            'ke',
            'ki',
            'kp',
            'kr',
            'xk',
            'kw',
            'kg',
            'la',
            'lv',
            'lb',
            'ls',
            'lr',
            'ly',
            'li',
            'lt',
            'lu',
            'mo',
            'mk',
            'mg',
            'mw',
            'my',
            'mv',
            'ml',
            'mt',
            'mh',
            'mq',
            'mr',
            'mu',
            'yt',
            'mx',
            'fm',
            'md',
            'mc',
            'mn',
            'me',
            'ms',
            'ma',
            'mz',
            'mm',
            'na',
            'nr',
            'np',
            'nl',
            'an',
            'nc',
            'nz',
            'ni',
            'ne',
            'ng',
            'nu',
            'nf',
            'mp',
            'no',
            'om',
            'pk',
            'pw',
            'ps',
            'pa',
            'pg',
            'py',
            'pe',
            'ph',
            'pn',
            'pl',
            'pt',
            'pr',
            'qa',
            're',
            'ro',
            'ru',
            'rw',
            'sh',
            'kn',
            'lc',
            'pm',
            'vc',
            'ws',
            'bl',
            'sm',
            'st',
            'sa',
            'sn',
            'cs',
            'rs',
            'sc',
            'sl',
            'sg',
            'sx',
            'sk',
            'si',
            'sb',
            'so',
            'za',
            'gs',
            'es',
            'lk',
            'sd',
            'ss',
            'sr',
            'sj',
            'sz',
            'se',
            'ch',
            'sy',
            'tw',
            'tj',
            'tz',
            'th',
            'tl',
            'tg',
            'tk',
            'to',
            'tt',
            'tn',
            'tr',
            'tm',
            'tc',
            'tv',
            'ug',
            'ua',
            'ae',
            'gb',
            'us',
            'um',
            'uy',
            'uz',
            'vu',
            'va',
            've',
            'vn',
            'vg',
            'vi',
            'wf',
            'eh',
            'ye',
            'zm',
            'zw'
        ];
    }
}
